import { CopilotTeachingPopoverAnchorID } from './CopilotTeachingPopoverAnchorID';

export default function getAnchorIdKey(anchorIdValue?: string): string | undefined {
    if (!anchorIdValue) {
        return undefined;
    }

    return Object.keys(CopilotTeachingPopoverAnchorID).find(
        key =>
            CopilotTeachingPopoverAnchorID[key as keyof typeof CopilotTeachingPopoverAnchorID] ===
            anchorIdValue
    );
}
